import React, { useContext } from 'react';

import NumberFormat from 'react-number-format';
import AppContext from '../../context';

function Number(props) {
  const context = useContext(AppContext);
  const show_decimals = props.show_decimals;
  let prefix = null;
  if (props.usePrefix) {
    prefix = context.currencyPrefix;
  }

  const format = (value) => {
    if (Math.abs(value) >= 1e7) {
      return `${(value / 1e7).toFixed(2)} Crs`;
    }
    if (Math.abs(value) >= 1e5) {
      return `${(value / 1e5).toFixed(2)} Lakhs`;
    }
    return value;
  };

  const roundToPoints = (value, points) => {
    return parseFloat(value.toFixed(points));
  };

  const renderText = () => {
    return `${props.usePrefix ? context.currencyPrefix : ''}${format(
      props.value,
    )}`;
  };

  return (
    <NumberFormat
      value={
        show_decimals
          ? !props.points
            ? props.value
            : roundToPoints(props.value, props.points)
          : Math.floor(props.value)
      }
      displayType={'text'}
      thousandSeparator={true}
      thousandsGroupStyle="lakh"
      prefix={prefix}
      renderText={
        props.format && Math.abs(props.value) >= 1e5 ? renderText : null
      }
    />
  );
}

export default Number;
